export const translations = {
    survey_title: "Cost of Living survey",
    question_intro: "How much is this in you area: ",
    region_label: "Region",
    question: "How much is this in you area: ",
    save_label: "Save",
    next_label: "Next",
    close_label: "Close",
    thanks_title: "Thank you!",
    thanks_url_text: "Find out what prices are in your neighbourhood and we will tell you your living wage.",
}

export const getSurveyDefaults = () => {
    return {
        isSubmitted: false,
        questions: {},
        answers: {},
        data: {},
        getLanguage: function () {
            return this.data.locale.replace('_', '-')
        },
    }
}